module.exports = __webpack_public_path__ + "static/media/ms-icon-144x144.49e0ee73.png";